import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69765626"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Rent a Unit", -1))
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "form-field"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Customer", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-field" }, [
  /*#__PURE__*/_createElementVNode("small", { style: {"margin-bottom":"25px"} }, [
    /*#__PURE__*/_createElementVNode("b", null, "Note"),
    /*#__PURE__*/_createTextVNode(": In order to rent a unit, a customer is "),
    /*#__PURE__*/_createElementVNode("b", null, "required"),
    /*#__PURE__*/_createTextVNode(" to sign up for an account. If they don't have an account, go to their profile and click \"Edit profile\"")
  ])
], -1))
const _hoisted_8 = { class: "form-field" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Unit Type", -1))
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 1,
  class: "form-field"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Unit", -1))
const _hoisted_14 = {
  key: 0,
  class: "form-field"
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "form-field" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Start Date for Billing Cycle", -1))
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "form-field" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Promotions", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "None", -1))
const _hoisted_23 = ["value"]
const _hoisted_24 = { key: 2 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Plan", -1))
const _hoisted_26 = ["value"]
const _hoisted_27 = ["value"]
const _hoisted_28 = /*#__PURE__*/_createTextVNode("months")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" month")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "custom" }, "Custom", -1))
const _hoisted_31 = { key: 3 }
const _hoisted_32 = { class: "form-field" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "customAmount" }, "Monthly Price before Discount($)", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_35 = { class: "form-field" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "discount" }, "Discount (%)", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "discount" }, "Billing cycle", -1))
const _hoisted_39 = ["value"]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = {
  key: 4,
  class: "form-field"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Facility Tenant Protection", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "No Plan", -1))
const _hoisted_45 = ["value"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Auto Protect will be based off the agreement date if the agreement is signed after the move-in date. ", -1))
const _hoisted_47 = {
  key: 5,
  class: "form-field"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Insurance Plans", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "No Plan", -1))
const _hoisted_50 = ["value"]
const _hoisted_51 = { key: 6 }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "form-field" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Charge Deposit", -1))
const _hoisted_55 = { key: 7 }
const _hoisted_56 = { class: "form-field" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Deposit ($)", -1))
const _hoisted_58 = { class: "form-field" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Mark Deposit as previously paid", -1))
const _hoisted_60 = { class: "form-field" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Charge Setup Fee", -1))
const _hoisted_62 = { key: 8 }
const _hoisted_63 = { class: "form-field" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Setup Fee ($)", -1))
const _hoisted_65 = {
  key: 0,
  class: "form-field"
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Setup fee tax rate (%) ", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "No Tax", -1))
const _hoisted_68 = ["value"]
const _hoisted_69 = { class: "form-field" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Prorating Options", -1))
const _hoisted_71 = ["value"]
const _hoisted_72 = { class: "form-field" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Move-in Date", -1))
const _hoisted_74 = {
  key: 9,
  class: "form-field"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unit_id" }, "Tax rate (%)", -1))
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: null }, "No Tax", -1))
const _hoisted_77 = ["value"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Rent", -1))
const _hoisted_79 = { key: 0 }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Rent Promotion Amount", -1))
const _hoisted_81 = { key: 1 }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Prorated Rent", -1))
const _hoisted_83 = { key: 2 }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Prorated Rent", -1))
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Tax", -1))
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { key: 1 }
const _hoisted_88 = /*#__PURE__*/_createTextVNode(" Tenant Protection Fee ")
const _hoisted_89 = /*#__PURE__*/_createTextVNode("Insurance Fee")
const _hoisted_90 = { key: 0 }
const _hoisted_91 = /*#__PURE__*/_createTextVNode(" Prorated Tenant Protection Fee ")
const _hoisted_92 = /*#__PURE__*/_createTextVNode("Prorated Insurance Fee")
const _hoisted_93 = { key: 1 }
const _hoisted_94 = /*#__PURE__*/_createTextVNode(" Tenant Protection Fee Tax ")
const _hoisted_95 = /*#__PURE__*/_createTextVNode("Insurance Fee Tax")
const _hoisted_96 = { key: 0 }
const _hoisted_97 = { key: 1 }
const _hoisted_98 = { key: 4 }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Deposit", -1))
const _hoisted_100 = { key: 5 }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Setup Fee", -1))
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { key: 1 }
const _hoisted_104 = { key: 6 }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Setup Fee Tax", -1))
const _hoisted_106 = { key: 0 }
const _hoisted_107 = ["onClick"]
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Total Due", -1))
const _hoisted_109 = { key: 8 }
const _hoisted_110 = { key: 9 }
const _hoisted_111 = { key: 0 }
const _hoisted_112 = { class: "form-field" }
const _hoisted_113 = ["disabled"]
const _hoisted_114 = {
  key: 0,
  class: "col"
}
const _hoisted_115 = /*#__PURE__*/_createTextVNode(" Renting Unit ")
const _hoisted_116 = {
  key: 1,
  class: "col"
}

import { ref, watch, onMounted } from "vue";
import serverMessage from "@/methods/server_message";
import moment from "moment";
import BaseSpinner from "@/components/BaseSpinner.vue";

import api from "@virgodev/bazaar/functions/api";
import { UnitTypeInterface, TenantProtectionPlanInterface } from "@/types/unit";
import {
  TaxRateInterface,
  RentalInterface,
  FeesProductInterface,
  // eslint-disable-next-line
  PromotionInterface,
} from "@/types/customers";
import { UnitInterface } from "@/types/unit";
import FeeProduct from "./FeeProduct.vue";
// const router = useRouter();
import RentalSelfInsured from "@/components/RentalSelfInsured.vue";

// import { useStore } from "../store";
// const store = useStore();
// import { storeToRefs } from "pinia";
// const { facility } = storeToRefs(store);
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: String,
    required: false,
    default: null,
  },
  unitId: {
    type: String,
    required: false,
    default: null,
  },
  unitType: {
    type: String,
    required: false,
    default: null,
  },
  unitStatus: {
    type: String,
    required: false,
    default: "available",
  },
  reservationId: {
    type: String,
    required: false,
    default: null,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const status = ref("loading");
const amountRented = ref();
const unitTypes = ref(Array<UnitTypeInterface>());
const selectedUnitType = ref();
const selectedUnit = ref();
const selectedTaxRate = ref();
const selectedFeeTaxRate = ref();
const errors = ref("");
const customPrice = ref(false);
const formSubmitting = ref(false);
const customAmount = ref(null);
const tenantProtectionPlans = ref(Array<TenantProtectionPlanInterface>());
const customerRentals = ref(Array<RentalInterface>());
const selectedCustomer = ref();
const units = ref();
const router = useRouter();
const promotions = ref();
const filteredUnits = ref();

const taxRates = ref();
const billingOptions = ref([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
const proratingOptions = ref([
  { text: "No Prorating", value: "none" },
  {
    text: "Bill for first full month, Prorate second month billed now",
    value: "full_now",
  },
  {
    text: "Bill for first full month, Prorate second month billed later",
    value: "full_later",
  },
  {
    text: "Prorate this month and bill full billing cycle starting next month",
    value: "first_later",
  },
  {
    text: "Prorate this month and bill now for the first billing cycle",
    value: "first_now",
  },
]);
const disabledSelfInsured = ref(false);
const formErrors = ref<Record<string, string[]>>({});
const formFields = ref({
  creator_id: ref(""), //rental from customer
  customer_id: props.customerId ? Number(props.customerId) : null,
  move_in_on: moment().format("YYYY-MM-DD"),
  available_promotion_id: ref(),
  unit_type_id: "",
  additional_deposit: "",
  amount_rented_for: ref(""),
  available_tenant_protection_plan_id: "",
  billing_cycle: ref(1),
  charge_additional_deposit: "",
  charge_deposit: ref(true),
  charge_setup_fee: ref(true),
  deposit: ref(),
  discount_as_percentage: "",
  exempt_from_rate_management: ref(false),
  agreement_delivery_methods: ref(["email", "text"]),
  insurance_plan_id: "",
  mark_additional_deposit_as_paid: false,
  mark_deposit_as_paid: false,
  marketplace_reservation_id: ref(),
  plan_id: "",
  prorated_amount: "",
  prorated_insurance_premium: "",
  prorating: "none",
  rented_on: moment().format("YYYY-MM-DD"),
  setup_fee: ref(),
  setup_fee_tax_rate_id: "",
  tax_rate_id: "",
  unit_id: "",
  self_insured_policy_acknowledged_at: "",
  self_insured_policy_expires_on: "",
  self_insured_policy_number: "",
  self_insured_policy_provider: "",
  rent_tax_rate_id: ref(),
});
const feesAndProducts = ref(Array<FeesProductInterface>());
const totalFeesProducts = ref(0);
const insurancePlans = ref();
const facility = ref();

// Keep customer_id in sync when props.customerId resolves (e.g. from route params)
watch(
  () => props.customerId,
  (val) => {
    const id = val ? Number(val) : null;
    formFields.value.customer_id =
      id !== null && Number.isInteger(id) && id > 0 ? id : null;
  },
  { immediate: true }
);

onMounted(async () => {
  await getFacility();
  await getUnits();
  await getUnitTypes();
  await getPromotions();
  if (props.customerId) {
    await getCustomer();
    await getRentals();
  }
  status.value = "completed";
  if (props.unitId) {
    formFields.value.unit_id = props.unitId;
    let unit = units.value.filter(
      (item: UnitInterface) => item.id == props.unitId
    )[0];
    if (unit) {
      formFields.value.unit_type_id = unit.unit_type_id;
      selectedUnitType.value = unitTypes.value.filter(
        (item) => item.id == unit.unit_type_id
      )[0];
      selectedUnit.value = unit;
      await updateForm();
    }
  }
  if (props.unitType) {
    if (props.unitType != "null") {
      selectedUnitType.value = unitTypes.value.filter(
        (item) => item.id == props.unitType
      )[0];
    }
  }
  if (selectedUnitType.value) {
    if (
      facility.value.enabled_rental_coverage_signup_type ==
        "tenant_protection" &&
      selectedUnitType.value.allow_tenant_protection
    ) {
      await getProtectionPlans();
    } else if (
      facility.value.enabled_rental_coverage_signup_type == "insurance"
    ) {
      await getInsurances();
    } else {
      disabledSelfInsured.value = true;
    }
  }
});
async function getFacility() {
  errors.value = "";
  const response = await api({
    url: `facility/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    facility.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function updateSelfInsured(obj: {
  self_insured_policy_acknowledged_at: string;
  self_insured_policy_expires_on: string;
  self_insured_policy_provider: string;
  self_insured_policy_number: string;
}) {
  formFields.value.self_insured_policy_acknowledged_at =
    obj.self_insured_policy_acknowledged_at;
  formFields.value.self_insured_policy_expires_on =
    obj.self_insured_policy_expires_on;
  formFields.value.self_insured_policy_provider =
    obj.self_insured_policy_provider;
  formFields.value.self_insured_policy_number = obj.self_insured_policy_number;
}
async function getProtectionPlans() {
  errors.value = "";
  const response = await api({
    url: `available_tenant_protection_plans/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    tenantProtectionPlans.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getInsurances() {
  errors.value = "";
  const response = await api({
    url: `insurances/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    insurancePlans.value = response.body;
    formFields.value.insurance_plan_id = insurancePlans.value[0].id;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
let daysInMonth = moment(formFields.value.move_in_on).daysInMonth();

watch(selectedUnitType, () => {
  if (units.value && selectedUnitType.value) {
    filteredUnits.value = units.value.filter(
      (item: UnitInterface) => item.unit_type_id == selectedUnitType.value.id
    );
    if (!props.unitId) {
      selectedUnit.value = null;
    }
  }
});
watch(amountRented, () => {
  if (amountRented.value == "custom") {
    customPrice.value = true;
  } else if (amountRented.value.id) {
    formFields.value.amount_rented_for = amountRented.value.amount;
    formFields.value.plan_id = amountRented.value.id;
  } else {
    customPrice.value = false;
    formFields.value.amount_rented_for = amountRented.value;
    formFields.value.plan_id = "";
  }
});
watch(customAmount, () => {
  if (customAmount.value && amountRented.value == "custom") {
    formFields.value.amount_rented_for = customAmount.value;
  }
});
watch(formFields.value, () => {
  if (
    formFields.value.discount_as_percentage &&
    customAmount.value &&
    amountRented.value == "custom"
  ) {
    formFields.value.amount_rented_for = (
      Number(customAmount.value) -
      (Number(formFields.value.discount_as_percentage) / 100) *
        Number(customAmount.value)
    ).toString();
  }
  if (["first_now", "full_now"].includes(formFields.value.prorating)) {
    formFields.value.rented_on = moment(formFields.value.move_in_on)
      .add(2, "months")
      .set("date", 1)
      .format("YYYY-MM-DD")
      .toString();
  } else if (
    ["first_later", "full_later"].includes(formFields.value.prorating)
  ) {
    formFields.value.rented_on = moment(formFields.value.move_in_on)
      .add(1, "months")
      .set("date", 1)
      .format("YYYY-MM-DD")
      .toString();
  }
});
function updateFeesAndProducts(e: FeesProductInterface) {
  feesAndProducts.value.push(e);
  totalFeesProducts.value += Number(e.item_subtotal);
}
function proratedRent() {
  if (formFields.value.prorating != "none") {
    let currentDay = moment(formFields.value.move_in_on).format("DD");

    if (formFields.value.move_in_on) {
      let daysLeft = Number(daysInMonth) - Number(currentDay) + 1;
      let proratedAmount =
        Number(formFields.value.amount_rented_for) / daysInMonth;
      if (["full_now", "full_later"].includes(formFields.value.prorating)) {
        let daysInNextMonth = moment(formFields.value.move_in_on)
          .add(1, "months")
          .daysInMonth();
        daysLeft = Number(daysInNextMonth) - Number(currentDay) + 1;
        proratedAmount =
          Number(formFields.value.amount_rented_for) / daysInNextMonth;
      }
      return proratedAmount * daysLeft;
    }
    return "";
  }
  return null;
}
function proratedTenantFee() {
  if (formFields.value.prorating != "none") {
    let currentDay = moment(formFields.value.move_in_on).format("DD");

    let daysLeft = Number(daysInMonth) - Number(currentDay) + 1;
    let proratedAmount = Number(protectionPlan()) / daysInMonth;
    if (["full_now", "full_later"].includes(formFields.value.prorating)) {
      let daysInNextMonth = moment(formFields.value.move_in_on)
        .add(1, "months")
        .daysInMonth();
      daysLeft = Number(daysInNextMonth) - Number(currentDay) + 1;
      proratedAmount = Number(protectionPlan()) / daysInNextMonth;
    }
    if (formFields.value.prorating == "first_later") {
      if (formFields.value.available_tenant_protection_plan_id) {
        proratedAmount =
          Number(
            tenantProtectionPlans.value.filter(
              (item: TenantProtectionPlanInterface) =>
                item.id == formFields.value.available_tenant_protection_plan_id
            )[0].fee
          ) / daysInMonth;
      } else if (formFields.value.insurance_plan_id) {
        proratedAmount =
          Number(
            insurancePlans.value.filter(
              (item: { id: string }) =>
                item.id == formFields.value.insurance_plan_id
            )[0].premium
          ) / daysInMonth;
      }
    }
    return proratedAmount * daysLeft;
  }
  return null;
}
function removeFee(obj: FeesProductInterface) {
  feesAndProducts.value.splice(
    feesAndProducts.value.indexOf(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      feesAndProducts.value.find((item) => item == obj)
    ),
    1
  );
  if (totalFeesProducts.value) {
    totalFeesProducts.value -= Number(obj.item_subtotal);
  }
}
function rentTax() {
  if (selectedTaxRate.value) {
    let total = Number(rent());
    let prorated = proratedRent();
    if (prorated && formFields.value.prorating != "full_later") {
      total += Number(prorated);
    }
    if (rentPromotion()) {
      total -= rentPromotion();
    }

    return (Number(selectedTaxRate.value.value_as_percentage) / 100) * total;
  }
  return "";
}
function rent() {
  if (formFields.value.prorating == "first_later") {
    return 0.0;
  }
  return formFields.value.amount_rented_for;
}
function rentPromotion() {
  let promotion = promotions.value.filter(
    (item: { id: string }) => item.id == formFields.value.available_promotion_id
  )[0];
  let rentAmount = rent();
  if (promotion) {
    return (Number(promotion.percentage) / 100) * Number(rentAmount);
  } else {
    return 0;
  }
}
function rentTaxWithOutProrate() {
  if (selectedTaxRate.value) {
    let total = Number(formFields.value.amount_rented_for);

    return (Number(selectedTaxRate.value.value_as_percentage) / 100) * total;
  }
  return "";
}
function totalDue() {
  let total = 0;
  if (formFields.value.prorating != "first_later") {
    if (
      formFields.value.available_tenant_protection_plan_id ||
      formFields.value.insurance_plan_id
    ) {
      total += Number(protectionPlan());
    }
    if (formFields.value.available_promotion_id) {
      total += Number(rent()) - rentPromotion();
    } else {
      total += Number(rent());
    }
  }
  total += Number(rentTax()) + Number(protectionPlanTax());
  if (formFields.value.charge_deposit) {
    total += Number(formFields.value.deposit);
  }
  if (formFields.value.charge_setup_fee) {
    total += Number(formFields.value.setup_fee) + Number(setupFeeTax());
  }
  if (totalFeesProducts.value) {
    total += Number(totalFeesProducts.value);
  }
  if (formFields.value.prorating != "full_later") {
    let prorated_rent = proratedRent();
    let prorated_fee = proratedTenantFee();
    if (prorated_fee) {
      total += Number(prorated_fee);
    }
    if (prorated_rent) {
      total += Number(prorated_rent);
    }
  }

  total = Math.round(total * 100) / 100;
  return total;
}
function protectionPlan() {
  if (formFields.value.prorating == "first_later") {
    return 0.0;
  }
  if (formFields.value.available_tenant_protection_plan_id) {
    return Number(
      tenantProtectionPlans.value.filter(
        (item: TenantProtectionPlanInterface) =>
          item.id == formFields.value.available_tenant_protection_plan_id
      )[0].fee
    );
  } else if (formFields.value.insurance_plan_id) {
    return Number(
      insurancePlans.value.filter(
        (item: TenantProtectionPlanInterface) =>
          item.id == formFields.value.insurance_plan_id
      )[0].premium
    );
  }
  return 0.0;
}

async function getPlans(unit_type_id: number) {
  errors.value = "";
  let url = `plans/?facilityId=${props.facilityId}&unit_type_id=${unit_type_id}`;

  const response = await api({
    url,
  });
  if (response.status == 200) {
    return response.body;
  } else {
    return null;
  }
}
function protectionPlanTax() {
  if (selectedTaxRate.value) {
    let total = protectionPlan();

    if (proratedTenantFee() && formFields.value.prorating != "full_later") {
      total += Number(proratedTenantFee());
    }
    return (Number(selectedTaxRate.value.value_as_percentage) / 100) * total;
  } else {
    return 0.0;
  }
}
function protectionPlanTaxWithout() {
  if (
    formFields.value.available_tenant_protection_plan_id &&
    selectedTaxRate.value
  ) {
    let total = tenantProtectionPlans.value.filter(
      (item: TenantProtectionPlanInterface) =>
        item.id == formFields.value.available_tenant_protection_plan_id
    )[0].fee;
    return (
      (Number(selectedTaxRate.value.value_as_percentage) / 100) * Number(total)
    );
  } else if (formFields.value.insurance_plan_id && selectedTaxRate.value) {
    let total = insurancePlans.value.filter(
      (item: TenantProtectionPlanInterface) =>
        item.id == formFields.value.insurance_plan_id
    )[0].premium;
    return (
      (Number(selectedTaxRate.value.value_as_percentage) / 100) * Number(total)
    );
  } else {
    return 0.0;
  }
}
function upcomingDue() {
  let total =
    Number(formFields.value.amount_rented_for) +
    Number(rentTaxWithOutProrate());
  if (formFields.value.available_tenant_protection_plan_id) {
    total +=
      protectionPlanTaxWithout() +
      Number(
        tenantProtectionPlans.value.filter(
          (item: TenantProtectionPlanInterface) =>
            item.id == formFields.value.available_tenant_protection_plan_id
        )[0].fee
      );
  }
  if (formFields.value.insurance_plan_id) {
    total +=
      protectionPlanTaxWithout() +
      Number(
        insurancePlans.value.filter(
          (item: TenantProtectionPlanInterface) =>
            item.id == formFields.value.insurance_plan_id
        )[0].premium
      );
  }

  return total;
}

function setupFeeTax() {
  if (selectedFeeTaxRate.value) {
    return (
      (selectedFeeTaxRate.value.value_as_percentage / 100) *
      Number(formFields.value.setup_fee)
    );
  }
  return "";
}
async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    selectedCustomer.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getRentals() {
  errors.value = "";
  const response = await api({
    url: `rentals/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    let rentals = response.body;
    for (let rental of rentals) {
      let details = await getUnitDetails(rental);
      rental.details = details;
      let unit_type = unitTypes.value.filter(
        (item) => item.id == rental.details.unit_type_id
      )[0];
      if (unit_type) {
        rental.unit_type = unit_type;
      }
    }
    customerRentals.value = rentals;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

async function getUnits() {
  errors.value = "";
  let url = `units/?status=${props.unitStatus}&facilityId=${props.facilityId}`;

  const response = await api({
    url,
  });
  if (response.status == 200) {
    units.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getPromotions() {
  errors.value = "";
  let url = `available_promotions/?facilityId=${props.facilityId}`;

  const response = await api({
    url,
  });
  if (response.status == 200) {
    promotions.value = response.body.available_promotions;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getUnitDetails(rental: RentalInterface) {
  errors.value = "";
  const response = await api({
    url: `units/?id=${rental.unit_id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    return response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
  return null;
}
function updateForm() {
  if (selectedUnitType.value) {
    formFields.value.unit_type_id = selectedUnitType.value.id;
    formFields.value.amount_rented_for = selectedUnitType.value.price;
    amountRented.value = selectedUnitType.value.price;
    formFields.value.deposit = Number(selectedUnitType.value.deposit);
    selectedTaxRate.value = taxRates.value.filter(
      (item: TaxRateInterface) =>
        item.id == selectedUnitType.value.rent_tax_rate_id
    )[0];
    selectedFeeTaxRate.value = taxRates.value.filter(
      (item: TaxRateInterface) =>
        item.id == selectedUnitType.value.setup_fee_tax_rate_id
    )[0];
    formFields.value.tax_rate_id = selectedUnitType.value.rent_tax_rate_id;
    formFields.value.setup_fee_tax_rate_id =
      selectedUnitType.value.setup_fee_tax_rate_id;
    if (!formFields.value.setup_fee_tax_rate_id) {
      selectedFeeTaxRate.value = null;
    }
    if (!formFields.value.tax_rate_id) {
      selectedTaxRate.value = null;
    }
    if (selectedTaxRate.value) {
      formFields.value.tax_rate_id = selectedTaxRate.value.id;
    }
    formFields.value.setup_fee = Number(selectedUnitType.value.setup_fee);
    if (selectedUnit.value) {
      formFields.value.unit_id = selectedUnit.value.id;
    }
  }
}
async function getTaxRates() {
  errors.value = "";
  const response = await api({
    url: `tax_rates/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    taxRates.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getUnitTypes() {
  errors.value = "";
  const response = await api({
    url: `unit_types/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    unitTypes.value = response.body;
    for (let unit_type of unitTypes.value) {
      unit_type.plans = await getPlans(Number(unit_type.id));
    }
    await getTaxRates();
    selectedUnitType.value = unitTypes.value[0];
    updateForm();
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function submitForm() {
  const json = JSON.parse(JSON.stringify(formFields.value));
  if (formFields.value.plan_id && formFields.value.plan_id.length > 0) {
    delete json.amount_rented_for;
  }
  formErrors.value = {};
  formSubmitting.value = true;

  // Prevent ghost accounts: require valid customer_id when adding unit to existing account
  const custId = formFields.value.customer_id;
  if (custId == null || !Number.isInteger(custId) || custId <= 0) {
    formErrors.value = {
      non_field_errors: [
        "A valid customer is required to add a unit. Please select an existing customer first.",
      ],
    };
    formSubmitting.value = false;
    return;
  }

  if (json.charge_deposit) {
    json.charge_deposit = 1;
  }
  if (json.charge_setup_fee) {
    json.charge_setup_fee = 1;
  }
  let url = `create_rental/?facilityId=${props.facilityId}`;
  let method: "POST" | "PATCH" = "POST";
  if (props.unitStatus == "reserved") {
    json.reservation_id = props.reservationId;
  }
  if (props.unitStatus == "marketplace") {
    json.marketplace_reservation_id = props.reservationId;
  }
  const responseData = await api({
    url,
    method,
    json,
  });

  formSubmitting.value = false;
  if ([200, 201].includes(responseData.status)) {
    if (feesAndProducts.value.length) {
      await submitFeesProducts();
    } else {
      router.push({
        name: "customer_detail_ess",
        params: {
          id: props.customerId,
          facilityId: props.facilityId,
        },
      });
    }
  } else {
    // Pass along what the facility's API said: "an unexpected error" left the
    // agent with no idea whether the unit was rented or why it wasn't.
    formErrors.value = {
      non_field_errors: [
        serverMessage(
          responseData,
          `The unit was not rented (error ${responseData.status}). Nothing ` +
            "was charged. Check the form and try again."
        ),
      ],
    };
  }
}
async function submitFeesProducts() {
  for (let line of feesAndProducts.value) {
    const json = JSON.parse(JSON.stringify(line));
    delete json.item_subtotal;
    formSubmitting.value = true;
    let url = `line_items/?facilityId=${props.facilityId}`;

    const responseData = await api({
      url,
      method: "POST",
      json,
    });
    if ([200, 201].includes(responseData.status)) {
      router.push({
        name: "customer_detail_ess",
        params: {
          id: props.customerId,
          facilityId: props.facilityId,
        },
      });
    } else if (responseData.status === 400) {
      formErrors.value = responseData.body;
      if (formErrors.value.non_field_errors === undefined) {
        formErrors.value = {
          non_field_errors: [
            serverMessage(
              responseData,
              "The unit was rented, but a fee or product did not save. Add it " +
                "from the customer's account."
            ),
          ],
        };
      }
    } else {
      formErrors.value = {
        non_field_errors: [
          "Unable to communicate with the server. Please check your " +
            "connection and try again.",
        ],
      };
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.customerId && selectedCustomer.value)
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 0,
          to: {
      name: 'customer_detail_ess',
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Back to Customer: " + _toDisplayString(selectedCustomer.value.name), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    _hoisted_1,
    _createElementVNode("form", {
      class: "large-width-centered",
      onSubmit: _withModifiers(submitForm, ["prevent"])
    }, [
      (unitTypes.value)
        ? (_openBlock(), _createElementBlock("fieldset", _hoisted_3, [
            (status.value === 'loading')
              ? (_openBlock(), _createBlock(BaseSpinner, {
                  key: 0,
                  preset: "large"
                }))
              : _createCommentVNode("", true),
            (status.value == 'completed')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (selectedCustomer.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _hoisted_6,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCustomer.value.name) = $event)),
                          type: "text",
                          disabled: ""
                        }, null, 512), [
                          [_vModelText, selectedCustomer.value.name]
                        ]),
                        _hoisted_7
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedUnitType).value = $event)),
                      required: "",
                      class: "form-select",
                      disabled: __props.unitId != null || __props.unitType != null,
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (updateForm()))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unitTypes.value, (item) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: item + 'id',
                          value: item
                        }, [
                          (item.length === 0 && item.width === 0 && item.name)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(item.name), 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(item.length) + " x " + _toDisplayString(item.width), 1)
                              ], 64))
                        ], 8, _hoisted_11))
                      }), 128))
                    ], 40, _hoisted_10), [
                      [_vModelSelect, selectedUnitType.value]
                    ])
                  ]),
                  (filteredUnits.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _hoisted_13,
                        (filteredUnits.value == 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, " No units available for this unit type. Reselect another unit type. "))
                          : _createCommentVNode("", true),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedUnit).value = $event)),
                          required: "",
                          class: "form-select",
                          disabled: __props.unitId != null && __props.unitType == null,
                          onChange: _cache[4] || (_cache[4] = ($event: any) => (updateForm()))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUnits.value, (unit) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: unit + 'id',
                              value: unit
                            }, _toDisplayString(unit.name), 9, _hoisted_16))
                          }), 128))
                        ], 40, _hoisted_15), [
                          [_vModelSelect, selectedUnit.value]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formFields.value.rented_on) = $event)),
                      type: "date",
                      required: "",
                      disabled: 
              ['first_now', 'first_later', 'full_now', 'full_later'].includes(
                formFields.value.prorating
              )
            
                    }, null, 8, _hoisted_19), [
                      [_vModelText, formFields.value.rented_on]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    (promotions.value && promotions.value.length && selectedUnitType.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 0,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formFields.value.available_promotion_id) = $event)),
                          class: "form-select"
                        }, [
                          _hoisted_22,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(promotions.value, (promotion) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: promotion.id + 'promotion'
                            }, [
                              (
                  !promotion.expired &&
                  promotion.unit_types.find(
                    (item) => item.id == selectedUnitType.value.id
                  )
                )
                                ? (_openBlock(), _createElementBlock("option", {
                                    key: 0,
                                    value: promotion.id
                                  }, _toDisplayString(promotion.name) + " - " + _toDisplayString(promotion.description), 9, _hoisted_23))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ], 512)), [
                          [_vModelSelect, formFields.value.available_promotion_id]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  (selectedUnitType.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((amountRented).value = $event)),
                          class: "form-select",
                          required: ""
                        }, [
                          _createElementVNode("option", {
                            value: selectedUnitType.value.price
                          }, " $ " + _toDisplayString(selectedUnitType.value.price) + " per month ", 9, _hoisted_26),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedUnitType.value.plans, (plan) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: plan.id + 'plan',
                              value: plan
                            }, [
                              _createTextVNode(" Override Price Plan - $ " + _toDisplayString(plan.amount) + " per " + _toDisplayString(plan.months) + " ", 1),
                              (plan.months > 1)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_28
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _hoisted_29
                                  ], 64))
                            ], 8, _hoisted_27))
                          }), 128)),
                          _hoisted_30
                        ], 512), [
                          [_vModelSelect, amountRented.value]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (customPrice.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _hoisted_34,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((customAmount).value = $event)),
                            type: "number",
                            step: ".01",
                            required: ""
                          }, null, 512), [
                            [_vModelText, customAmount.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _hoisted_37,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formFields.value.discount_as_percentage) = $event)),
                            type: "number",
                            step: ".01",
                            required: ""
                          }, null, 512), [
                            [_vModelText, formFields.value.discount_as_percentage]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_38,
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formFields.value.billing_cycle) = $event)),
                            class: "form-select",
                            required: ""
                          }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(billingOptions.value, (cycle) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: cycle + 'cycle',
                                value: cycle
                              }, [
                                (cycle != 0)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(cycle) + " months", 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_41, "28 days"))
                              ], 8, _hoisted_39))
                            }), 128))
                          ], 512), [
                            [_vModelSelect, formFields.value.billing_cycle]
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (tenantProtectionPlans.value && tenantProtectionPlans.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _hoisted_43,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formFields.value.available_tenant_protection_plan_id) = $event)),
                          class: "form-select"
                        }, [
                          _hoisted_44,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tenantProtectionPlans.value, (plan) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: plan.id + 'plan',
                              value: plan.id
                            }, " $" + _toDisplayString(plan.limit) + " protection for $" + _toDisplayString(plan.fee) + " per month ", 9, _hoisted_45))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, formFields.value.available_tenant_protection_plan_id]
                        ]),
                        _hoisted_46
                      ]))
                    : _createCommentVNode("", true),
                  (insurancePlans.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                        _hoisted_48,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formFields.value.insurance_plan_id) = $event)),
                          class: "form-select"
                        }, [
                          _hoisted_49,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(insurancePlans.value, (plan) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: plan.id + 'plan',
                              value: plan.id
                            }, _toDisplayString(plan.summary), 9, _hoisted_50))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, formFields.value.insurance_plan_id]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (!disabledSelfInsured.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        (
              formFields.value.insurance_plan_id ||
              formFields.value.available_tenant_protection_plan_id
            )
                          ? (_openBlock(), _createElementBlock("small", _hoisted_52, "Another protection/insurance plan has been selected"))
                          : _createCommentVNode("", true),
                        _createVNode(RentalSelfInsured, { onSelf_insured: updateSelfInsured })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_53, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formFields.value.charge_deposit) = $event)),
                      type: "checkbox",
                      class: "form-check-input"
                    }, null, 512), [
                      [_vModelCheckbox, formFields.value.charge_deposit]
                    ]),
                    _hoisted_54
                  ]),
                  (formFields.value.charge_deposit)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _hoisted_57,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formFields.value.deposit) = $event)),
                            type: "number",
                            step: ".01",
                            required: ""
                          }, null, 512), [
                            [_vModelText, formFields.value.deposit]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formFields.value.mark_deposit_as_paid) = $event)),
                            type: "checkbox",
                            class: "form-check-input"
                          }, null, 512), [
                            [_vModelCheckbox, formFields.value.mark_deposit_as_paid]
                          ]),
                          _hoisted_59
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_60, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formFields.value.charge_setup_fee) = $event)),
                      type: "checkbox",
                      class: "form-check-input"
                    }, null, 512), [
                      [_vModelCheckbox, formFields.value.charge_setup_fee]
                    ]),
                    _hoisted_61
                  ]),
                  (formFields.value.charge_setup_fee)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formFields.value.setup_fee) = $event)),
                            type: "number",
                            step: ".01",
                            required: ""
                          }, null, 512), [
                            [_vModelText, formFields.value.setup_fee]
                          ])
                        ]),
                        (taxRates.value && taxRates.value.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                              _hoisted_66,
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((selectedFeeTaxRate).value = $event)),
                                class: "form-select",
                                required: ""
                              }, [
                                _hoisted_67,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxRates.value, (tax) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: tax.id + 'tax',
                                    value: tax
                                  }, _toDisplayString(tax.value_as_percentage), 9, _hoisted_68))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, selectedFeeTaxRate.value]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(FeeProduct, {
                    "customer-id": __props.customerId,
                    "facility-id": __props.facilityId,
                    onFeesAndProducts: updateFeesAndProducts
                  }, null, 8, ["customer-id", "facility-id"]),
                  _createElementVNode("div", _hoisted_69, [
                    _hoisted_70,
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formFields.value.prorating) = $event)),
                      class: "form-select"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(proratingOptions.value, (rate) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: rate.value + 'rate',
                          value: rate.value
                        }, _toDisplayString(rate.text), 9, _hoisted_71))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, formFields.value.prorating]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _hoisted_73,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formFields.value.move_in_on) = $event)),
                      type: "date",
                      required: ""
                    }, null, 512), [
                      [_vModelText, formFields.value.move_in_on]
                    ])
                  ]),
                  (taxRates.value && taxRates.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                        _hoisted_75,
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((selectedTaxRate).value = $event)),
                          class: "form-select",
                          required: ""
                        }, [
                          _hoisted_76,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(taxRates.value, (tax) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: tax.id + 'tax',
                              value: tax
                            }, _toDisplayString(tax.value_as_percentage), 9, _hoisted_77))
                          }), 128))
                        ], 512), [
                          [_vModelSelect, selectedTaxRate.value]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("table", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_78,
                      _createElementVNode("td", null, "$" + _toDisplayString(rent()), 1)
                    ]),
                    (formFields.value.available_promotion_id)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_79, [
                          _hoisted_80,
                          _createElementVNode("td", null, "$" + _toDisplayString(rentPromotion().toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (proratedRent() && formFields.value.prorating != 'full_later')
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_81, [
                          _hoisted_82,
                          _createElementVNode("td", null, "$" + _toDisplayString(Number(proratedRent()).toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (formFields.value.prorated_amount)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_83, [
                          _hoisted_84,
                          _createElementVNode("td", null, "$" + _toDisplayString(formFields.value.prorated_amount), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _hoisted_85,
                      (selectedTaxRate.value && rentTax())
                        ? (_openBlock(), _createElementBlock("td", _hoisted_86, " $" + _toDisplayString(Number(rentTax()).toFixed(2)) + " (" + _toDisplayString(selectedTaxRate.value.value_as_percentage) + "%) ", 1))
                        : (_openBlock(), _createElementBlock("td", _hoisted_87))
                    ]),
                    (
              tenantProtectionPlans.value &&
              (formFields.value.available_tenant_protection_plan_id ||
                formFields.value.insurance_plan_id)
            )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", null, [
                              (formFields.value.available_tenant_protection_plan_id)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _hoisted_88
                                  ], 64))
                                : (formFields.value.insurance_plan_id)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _hoisted_89
                                    ], 64))
                                  : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", null, "$" + _toDisplayString(protectionPlan().toFixed(2)), 1)
                          ]),
                          (proratedTenantFee() && formFields.value.prorating != 'full_later')
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_90, [
                                _createElementVNode("td", null, [
                                  (formFields.value.available_tenant_protection_plan_id)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_91
                                      ], 64))
                                    : (formFields.value.insurance_plan_id)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _hoisted_92
                                        ], 64))
                                      : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("td", null, "$" + _toDisplayString(proratedTenantFee()?.toFixed(2)), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (tenantProtectionPlans.value)
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_93, [
                                _createElementVNode("td", null, [
                                  (formFields.value.available_tenant_protection_plan_id)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_94
                                      ], 64))
                                    : (formFields.value.insurance_plan_id)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _hoisted_95
                                        ], 64))
                                      : _createCommentVNode("", true)
                                ]),
                                (selectedTaxRate.value && protectionPlanTax())
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_96, " $" + _toDisplayString(protectionPlanTax().toFixed(2)) + " (" + _toDisplayString(selectedTaxRate.value.value_as_percentage) + "%) ", 1))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_97))
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (formFields.value.charge_deposit)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_98, [
                          _hoisted_99,
                          _createElementVNode("td", null, "$" + _toDisplayString(formFields.value.deposit), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (formFields.value.charge_setup_fee)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_100, [
                          _hoisted_101,
                          (formFields.value.setup_fee)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_102, "$" + _toDisplayString(formFields.value.setup_fee), 1))
                            : (_openBlock(), _createElementBlock("td", _hoisted_103))
                        ]))
                      : _createCommentVNode("", true),
                    (formFields.value.charge_setup_fee)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_104, [
                          _hoisted_105,
                          (selectedFeeTaxRate.value)
                            ? (_openBlock(), _createElementBlock("td", _hoisted_106, " $" + _toDisplayString(Number(setupFeeTax()).toFixed(2)) + " (" + _toDisplayString(selectedFeeTaxRate.value.value_as_percentage) + "%) ", 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (feesAndProducts.value.length)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 7 }, _renderList(feesAndProducts.value, (item) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.id + 'item'
                          }, [
                            _createElementVNode("td", null, _toDisplayString(item.action_name) + " due on " + _toDisplayString(item.due_on), 1),
                            _createElementVNode("td", null, [
                              _createTextVNode(" $" + _toDisplayString(Number(item.item_subtotal).toFixed(2)) + " ", 1),
                              _createElementVNode("a", {
                                onClick: ($event: any) => (removeFee(item))
                              }, "remove", 8, _hoisted_107)
                            ])
                          ]))
                        }), 128))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _hoisted_108,
                      _createElementVNode("td", null, "$" + _toDisplayString(totalDue().toFixed(2)), 1)
                    ]),
                    (proratedTenantFee() && formFields.value.prorating == 'full_later')
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_109, [
                          _createElementVNode("td", null, [
                            (formFields.value.available_tenant_protection_plan_id)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" Prorated Tenant Protection Fee due on " + _toDisplayString(formFields.value.rented_on), 1)
                                ], 64))
                              : (formFields.value.insurance_plan_id)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" Prorated Insurance Fee due on " + _toDisplayString(formFields.value.rented_on), 1)
                                  ], 64))
                                : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("td", null, "$" + _toDisplayString(proratedTenantFee()?.toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (proratedRent() && formFields.value.prorating == 'full_later')
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_110, [
                          _createElementVNode("td", null, "Prorated second month due on " + _toDisplayString(formFields.value.rented_on), 1),
                          _createElementVNode("td", null, "$" + _toDisplayString(Number(proratedRent()).toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, " Amount due every month starting on " + _toDisplayString(formFields.value.rented_on), 1),
                      _createElementVNode("td", null, [
                        _createTextVNode(" $" + _toDisplayString(upcomingDue().toFixed(2)), 1),
                        (taxRates.value && taxRates.value.length)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_111, " (tax included)"))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_112, [
        _createElementVNode("button", {
          disabled: formSubmitting.value,
          type: "submit",
          class: "btn btn-text"
        }, [
          (formSubmitting.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                _hoisted_115,
                _createVNode(BaseSpinner)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_116, "Rent Unit"))
        ], 8, _hoisted_113)
      ]),
      (formErrors.value.non_field_errors !== undefined)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 1,
            variant: "danger",
            class: "js-form-error",
            dismissible: "",
            onDismissed: _cache[22] || (_cache[22] = ($event: any) => (formErrors.value = {}))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(formErrors.value.non_field_errors[0]), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 40, _hoisted_2)
  ], 64))
}
}

})